import { useCallback, useEffect } from 'react'
import {
  consumeNativeWidgetIntent,
  onNativeWidgetResume,
  type NativeWidgetIntent,
} from '../services/nativeWidgetBridge'

export const useNativeWidgetIntent = (handler: (intent: NativeWidgetIntent) => void) => {
  const checkIntent = useCallback(() => {
    void consumeNativeWidgetIntent().then((intent) => {
      if (intent) handler(intent)
    })
  }, [handler])

  useEffect(() => {
    checkIntent()
    const timer = window.setTimeout(checkIntent, 650)
    const removeResume = onNativeWidgetResume(checkIntent)
    const onFocus = () => checkIntent()
    window.addEventListener('focus', onFocus)
    return () => {
      window.clearTimeout(timer)
      window.removeEventListener('focus', onFocus)
      removeResume()
    }
  }, [checkIntent])
}
